/* global Cookiebot */

import { initDeleteButtons, closeReadingList } from './reading-list'

export const LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS = 'reading_list_bookmarks'
export const LOCAL_STORAGE_KEY_READING_LIST_REMINDERS = 'reading_list_reminders'

export default function readingListButton(){
  window.addEventListener('posts-loaded', () => {
    initButtons()
  })

  initButtons()

  const openCookieInfoLink = document.querySelector('.js-reading-list-cookie-link')
  if (openCookieInfoLink) {
    openCookieInfoLink.addEventListener('click', () => {
      showCookieDialog()
      closeReadingList()
    })
  }

  function initButtons () {
    for (const button of document.querySelectorAll('.js-save-to-reading-list')) {
      const post = JSON.parse(button.dataset.postData)
      updateButtonState(button)

      button.addEventListener('click', (event) => {
        event.stopPropagation()

        if (isInReadingList(post)) {
          removeFromReadingList(post)
        } else {
          addToReadingList(post)
        }
        updateButtonState()
      })
    }
  }
}

function isInReadingList(post) {
  const readingList = getReadingList()

  return readingList.some(item => item.postId === post.postId)
}

function isInReminders(post) {
  const reminders = getReadingListReminders()

  return reminders.some(item => item.postId === post.postId)
}

function showCookieDialog () {
  const readingListDialog = document.getElementById("reading-list-cookie-dialog")
  readingListDialog.showModal()

  const dialogConfirmButton = document.getElementById("reading-list-dialog-confirm")
  dialogConfirmButton.addEventListener("click", () => {
    readingListDialog.close()
    Cookiebot.renew()
  })

  const dialogCloseButton = document.getElementById("reading-list-dialog-close")
  dialogCloseButton.addEventListener("click", () => {
    readingListDialog.close()
  })
}

export function addToReminders(post) {
  if (!Cookiebot.consent.preferences) {
    return
  }

  if (isInReminders(post)) return

  const reminders = getReadingListReminders()
  reminders.unshift(post)

  const remindersContainer = document.querySelector('.js-reading-list-reminders').getElementsByTagName('ul')[0]

  if (reminders.length > 5) {
    reminders.length = 5
    remindersContainer.children[remindersContainer.children.length - 1].remove()
  }

  localStorage.setItem(LOCAL_STORAGE_KEY_READING_LIST_REMINDERS, JSON.stringify(reminders))


  const li = document.createElement('li')

  li.id = 'reminder-' + post.postId
  li.dataset.item = JSON.stringify(post)

  li.innerHTML = `
    <button class="js-reading-list_delete-button delete-button">
      <span class="btn__icon icon icon-close"></span>
    </button>
    <a href="${post.permalink}">${post.title}</a>
  `
  remindersContainer.prepend(li)

  updateEmptyPlaceholderVisibility()
  initDeleteButtons()
}

export function addToReadingList(post) {

  if (!Cookiebot.consent.preferences) {
    showCookieDialog()
    return
  }

  const readingList = getReadingList()
  readingList.unshift(post)

  localStorage.setItem(LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS, JSON.stringify(readingList))

  const readingListContainer = document.querySelector('.js-reading-list').getElementsByTagName('ul')[0]
  const li = document.createElement('li')

  li.id = 'bookmark-' + post.postId
  li.dataset.item = JSON.stringify(post)

  li.innerHTML = `
    <button class="js-reading-list_delete-button delete-button">
      <span class="btn__icon icon icon-close"></span>
    </button>
    <a href="${post.permalink}">${post.title}</a>
  `
  readingListContainer.prepend(li)

  updateEmptyPlaceholderVisibility()
  initDeleteButtons()

  const notificationEl = document.querySelector('.js-reading-list-notification')
  notificationEl?.classList.add('visible')

  setTimeout(() => {
    notificationEl.classList.remove('visible')
  }, 2500)
}

export function removeFromReadingList(post) {
  const readingList = getReadingList()
  const filteredReadingList = readingList.filter(item => item.postId !== post.postId)

  document.getElementById('bookmark-' + post.postId).remove()

  localStorage.setItem(LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS, JSON.stringify(filteredReadingList))

  updateEmptyPlaceholderVisibility()
}

export function removeFromReminders(post) {
  const reminders = getReadingListReminders()
  const filteredReminders = reminders.filter(item => item.postId !== post.postId)

  document.getElementById('reminder-' + post.postId).remove()

  localStorage.setItem(LOCAL_STORAGE_KEY_READING_LIST_REMINDERS, JSON.stringify(filteredReminders))

  updateEmptyPlaceholderVisibility()
}

export function updateButtonState() {
  for (const button of document.querySelectorAll('.js-save-to-reading-list')) {
    const post = JSON.parse(button.dataset.postData)
    const postTitle = post.title;
    button.setAttribute('aria-pressed', isInReadingList(post) ? 'true' : 'false')
    button.setAttribute('aria-label', isInReadingList(post) ? `${objectL10n.remove} '${postTitle}' ${objectL10n.from_reading_list}` : `${objectL10n.add} '${postTitle}' ${objectL10n.to_reading_list}`)
  }
}

export function updateEmptyPlaceholderVisibility() {
  const emptyPlaceholderEl = document.querySelector('.js-reading-list-bookmarks-empty-placeholder')

  if (emptyPlaceholderEl) {
    const numItems = getReadingList().length
    if (numItems > 0) {
      emptyPlaceholderEl.style.display = 'none'
    } else {
      emptyPlaceholderEl.style.display = 'block'
    }
  }

  const remindersEl = document.querySelector('.js-reading-list-reminders')
  const remindersEmptyPlaceholderEl = document.querySelector('.js-reading-list-reminders-empty-placeholder')
  if (remindersEl) {
    const numReminders = getReadingListReminders().length
    if (numReminders > 0) {
      remindersEl.style.display = 'block'
      remindersEmptyPlaceholderEl.style.display = 'none'
    } else {
      remindersEl.style.display = 'none'
      remindersEmptyPlaceholderEl.style.display = 'none'
    }
  }

}

function getReadingList () {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS)) || []
}

function getReadingListReminders () {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_READING_LIST_REMINDERS)) || []
}
